export default "__VITE_ASSET__CwOA2OHK__"